import React from 'react';
import {
    Heading1,
    TextLead,
    FlexDiv,
    SpaceBetweenDiv,
    ThemedButton,
    LightTooltip,
} from '@awarego-ui/components';

function WizardStepHeader({
    title,
    subtitle,
    summary,
    buttonText,
    onButtonClick,
    buttonDisabled,
    buttonTooltip,
}) {
    const actionButton = buttonText ? (
        <ThemedButton
            mode="secondary"
            onClick={onButtonClick}
            text={buttonText}
            disabled={buttonDisabled}
        />
    ) : null;

    return (
        <>
            <SpaceBetweenDiv alignStart gap={16} mt={40}>
                <FlexDiv column>
                    <Heading1 displayBlock mb={4}>
                        {title}
                    </Heading1>
                    {subtitle && (
                        <TextLead lighter mb={16}>
                            {subtitle}
                        </TextLead>
                    )}
                    {summary && (
                        <TextLead bold themed>
                            {summary}
                        </TextLead>
                    )}
                </FlexDiv>
                {actionButton &&
                    (buttonDisabled && buttonTooltip ? (
                        <LightTooltip title={buttonTooltip} placement="left">
                            <span>{actionButton}</span>
                        </LightTooltip>
                    ) : (
                        actionButton
                    ))}
            </SpaceBetweenDiv>
        </>
    );
}

export default WizardStepHeader;
